'use strict';

module.exports = strong;

var all = require('../all');

/* Transform importance. */
function strong(h, node) {
  return h(node, 'strong', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/mdast-util-to-hast/lib/handlers/strong.js
// module id = 976
// module chunks = 0